import { render, staticRenderFns } from "./AnalyseResults.vue?vue&type=template&id=50d15c85&"
import script from "./AnalyseResults.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyseResults.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AnalyseResults.vue?vue&type=style&index=0&id=50d15c85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports